import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import RouteLoading from "../components/Loaders/RouteLoading";
import useLoggedIn from "../hooks/useLoggedIn";
import UserLayout from "../Layout/UserLayout";

const AuthProtectedRoutes = () => {
  const { isLoggedIn, isLoading } = useLoggedIn();

  if (isLoading) return <UserLayout isLoading={true} />;

  return isLoggedIn ? <UserLayout /> : <Navigate to="/sign-in" />;
};

export default AuthProtectedRoutes;
